import Resource from './Resource'
import i18n from '@/lang/i18n'
import sessionStore from '@/session/sessionStore'
import { ModuleOperation } from '@/api/operations/models/module-operation'
import { store } from '@/store/store'
import { UserType } from '@/api/resources/common/initialization/common-initialization.dto.ts'

export class Module {
    constructor({ moduleCode, routeName, getLabel, icon, storeModalState, uiComponentModalState, showDialogBox }) {
        this.moduleCode = moduleCode
        this.routeName = routeName
        this.getLabel = getLabel
        this.icon = icon
        this.storeModalState = storeModalState
        this.uiComponentModalState = uiComponentModalState
        this.showDialogBox = showDialogBox
    }
    get label() {
        return this.getLabel()
    }
}

export const MODULES = {
    [ModuleOperation.ARCHIVE]: {
        moduleCode: ModuleOperation.ARCHIVE,
        routeName: 'archiveGrid',
        getLabel: () => i18n.tc('global.archiveManagement'),
        icon: 'far fa-archive',
        showDialogBox: false
    },
    [ModuleOperation.AUDIT]: {
        moduleCode: ModuleOperation.AUDIT,
        routeName: 'auditGrid',
        getLabel: () => i18n.tc('audit.sidebar.auditTitle'),
        icon: 'fal fa-ballot-check',
        showDialogBox: false
    },
    [ModuleOperation.BILLING]: {
        moduleCode: ModuleOperation.BILLING,
        routeName: 'billingGrid',
        getLabel: () => i18n.tc('accounting.sidebar.title'),
        icon: 'fal fa-calculator-alt',
        storeModalState: 'billingModalState',
        uiComponentModalState: 'uicomponent.billing.modalconfig',
        showDialogBox: true
    },
    [ModuleOperation.CONFIGURATION]: {
        moduleCode: ModuleOperation.CONFIGURATION,
        routeName: 'ConfigurationHome',
        getLabel: () => i18n.tc('global.config'),
        icon: 'fal fa-cog',
        showDialogBox: false
    },
    // Microstrategy integration hidden
    /* [ModuleOperation.CONTROL_PANEL]: {
        moduleCode: ModuleOperation.CONTROL_PANEL,
        routeName: 'controlPanel',
        getLabel: () => i18n.tc('global.controlPanel'),
        icon: 'fal fa-chart-pie'
    }, */
    [ModuleOperation.CORRELATION]: {
        moduleCode: ModuleOperation.CORRELATION,
        getLabel: () => i18n.tc('global.diagnosticCorrelation'),
        icon: ['fal', 'question'],
        showDialogBox: true
    },
    [ModuleOperation.EXPENSE_AND_BILLING]: {
        moduleCode: ModuleOperation.EXPENSE_AND_BILLING,
        getLabel: () => i18n.tc('global.expenseAndBilling'),
        icon: ['fal', 'file-alt'],
        showDialogBox: true
    },
    [ModuleOperation.DASHBOARD]: {
        moduleCode: ModuleOperation.DASHBOARD,
        routeName: 'home',
        getLabel: () => i18n.tc('dashboard.label'),
        showDialogBox: true
    },
    [ModuleOperation.DIAGNOSE]: {
        moduleCode: ModuleOperation.DIAGNOSE,
        routeName: 'diagnosisGrid',
        getLabel: () => i18n.tc('global.diagnosis'),
        icon: 'far fa-file-chart-line',
        storeModalState: 'diagnoseModalsState',
        uiComponentModalState: 'uicomponent.diagnosis.modalconfig',
        showDialogBox: true
    },
    [ModuleOperation.GROSSING]: {
        moduleCode: ModuleOperation.GROSSING,
        routeName: 'grossingGrid',
        getLabel: () => i18n.tc('global.grossing'),
        icon: 'far fa-scalpel-path',
        storeModalState: 'grossingModalsState',
        uiComponentModalState: 'uicomponent.grossing.modalconfig',
        showDialogBox: true
    },
    [ModuleOperation.INCIDENT]: {
        moduleCode: ModuleOperation.INCIDENT,
        routeName: 'incidentsModule',
        getLabel: () => i18n.tc('entities.incident.incidentsManagement'),
        icon: 'far fa-exclamation-triangle',
        showDialogBox: false
    },
    [ModuleOperation.LABORATORY]: {
        moduleCode: ModuleOperation.LABORATORY,
        routeName: 'laboratoryModule',
        getLabel: () => i18n.tc('global.laboratory'),
        icon: 'far fa-vials',
        storeModalState: 'laboratoryModalsState',
        uiComponentModalState: 'uicomponent.laboratory.modalconfig',
        showDialogBox: true
    },
    [ModuleOperation.PETITIONER]: {
        moduleCode: ModuleOperation.PETITIONER,
        routeName: 'clinicalGrid',
        getLabel: () => i18n.tc('global.request', 2),
        icon: 'far fa-file-medical',
        storeModalState: 'clinicalModalsState',
        uiComponentModalState: 'uicomponent.petitioner.modalconfig',
        showDialogBox: true
    },
    [ModuleOperation.PRINT_CENTER]: {
        moduleCode: ModuleOperation.PRINT_CENTER,
        getLabel: () => i18n.tc('global.printCenter'),
        icon: ['fal', 'question'],
        showDialogBox: true
    },
    [ModuleOperation.PRODUCTS_AND_STORAGE]: {
        moduleCode: ModuleOperation.PRODUCTS_AND_STORAGE,
        getLabel: () => i18n.tc('global.productsAndWarehouse'),
        icon: ['fal', 'question'],
        showDialogBox: true
    },
    [ModuleOperation.QUALITY]: {
        moduleCode: ModuleOperation.QUALITY,
        getLabel: () => i18n.tc('global.quality'),
        icon: ['fal', 'award'],
        showDialogBox: true
    },
    [ModuleOperation.REGISTRY]: {
        moduleCode: ModuleOperation.REGISTRY,
        routeName: 'caseGrid',
        getLabel: () => i18n.tc('global.register'),
        icon: 'far fa-cabinet-filing',
        storeModalState: 'registryModalsState',
        uiComponentModalState: 'uicomponent.registry.modalconfig',
        showDialogBox: true
    },
    [ModuleOperation.REGISTRY_REQUEST]: {
        moduleCode: ModuleOperation.REGISTRY_REQUEST,
        routeName: 'requestGrid',
        getLabel: () => i18n.tc('global.requestBox'),
        icon: 'far fa-envelope-open-text',
        storeModalState: 'registryModalsState',
        uiComponentModalState: 'uicomponent.registry.modalconfig',
        showDialogBox: true
    },
    [ModuleOperation.SCIENTIFIC_PANEL]: {
        moduleCode: ModuleOperation.SCIENTIFIC_PANEL,
        routeName: 'scientific-analysis-module',
        getLabel: () => i18n.tc('global.scientificAnalysis'),
        icon: 'fal fa-atom-alt',
        showDialogBox: false
    },
    [ModuleOperation.SHIPMENTS]: {
        moduleCode: ModuleOperation.SHIPMENTS,
        routeName: 'shipmentsGrid',
        getLabel: () => i18n.tc('shipments.sidebar.shipments'),
        icon: 'far fa-box',
        storeModalState: 'shipmentModalState',
        uiComponentModalState: 'uicomponent.shipments.modalconfig',
        showDialogBox: true
    },
    [ModuleOperation.STATISTICS_PANEL]: {
        moduleCode: ModuleOperation.STATISTICS_PANEL,
        routeName: 'StatisticalAnalysisHome',
        getLabel: () => i18n.tc('global.statisticalAnalysis'),
        icon: 'fal fa-analytics',
        showDialogBox: false
    },
    [ModuleOperation.WASTE]: {
        moduleCode: ModuleOperation.WASTE,
        routeName: 'wasteGrid',
        getLabel: () => i18n.tc('global.wasteManagement'),
        icon: 'far fa-trash',
        showDialogBox: false
    }
}

class ModuleResource extends Resource {
    getLaboratoryModules(laboratoriesConfiguration, laboratoryId) {
        if (store.getters.userInformation?.userType === UserType.PETITIONER) {
            return laboratoriesConfiguration?.find(configuration => configuration.petitionerModuleActive)
        }

        const laboratoryConfiguration =
            laboratoriesConfiguration?.find(configuration => configuration.laboratory.labId === laboratoryId)
        this.addRequestMailboxModuleIfClinicalModuleActiveAndRegistryAccessible(laboratoryConfiguration)
        return laboratoryConfiguration
    }
    addRequestMailboxModuleIfClinicalModuleActiveAndRegistryAccessible(laboratoryConfiguration) {
        const requestMailboxModuleIndex = laboratoryConfiguration?.modules?.findIndex(module => module.moduleCode === ModuleOperation.REGISTRY_REQUEST)
        const registryModuleIndex = laboratoryConfiguration?.modules?.findIndex(module => module.moduleCode === ModuleOperation.REGISTRY)
        const isRegistryAccessible = registryModuleIndex >= 0
        const isRequestMailboxModuleMissing = requestMailboxModuleIndex < 0
        if (laboratoryConfiguration?.petitionerModuleActive && isRegistryAccessible && isRequestMailboxModuleMissing) {
            laboratoryConfiguration?.modules.splice(registryModuleIndex, 0, { moduleCode: ModuleOperation.REGISTRY_REQUEST })
        }
    }
    getModuleRouteNameFromModuleCode(moduleCode) {
        return MODULES[moduleCode] ? MODULES[moduleCode].routeName : null
    }
    getDashboardPseudoModule() {
        return new Module(MODULES[ModuleOperation.DASHBOARD])
    }
    getModulesFromLaboratoryConfiguration(laboratoriesConfiguration, labId) {
        const selectedLaboratoryConfiguration = this.getLaboratoryModules(laboratoriesConfiguration, labId)
        const existingModules = this.keepExistingModules(selectedLaboratoryConfiguration?.modules)
        const modules = existingModules?.map(m => new Module(MODULES[m.moduleCode]))
        if (sessionStore.hasAnyConfigurationOperation()) {
            modules.push(new Module(MODULES[ModuleOperation.CONFIGURATION]))
        }
        return modules
    }
    keepExistingModules(modules) {
        return modules?.filter(m => {
            const exists = Boolean(MODULES[m.moduleCode])
            if (!exists) {
                console.error(`module ${m.moduleCode} not found`)
            }
            return exists
        })
    }
}

export default new ModuleResource()
